import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistDE() {
  const articleData = {
    title: 'Ist Ihr Ex ein verdeckter Narzisst? (Die Texte lügen nicht)',
    description: 'Fragen Sie sich, ob Ihr Ex ein verdeckter Narzisst ist? Entdecken Sie 7 subtile manipulative Verhaltensweisen, die unsere KI sofort in Textnachrichten erkennt.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Toxic Detector Redaktion'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Was ist ein verdeckter Narzisst und wie unterscheidet er sich von offenen Narzissten?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Verdeckte Narzissten verstecken ihre manipulativen Verhaltensweisen hinter Charme, subtilen emotionalen Taktiken und passiv-aggressiven Nachrichten, im Gegensatz zu offensichtlichen Narzissten.'
      }
    }, {
      '@type': 'Question',
      name: 'Kann KI verdeckten Narzisstmus in Textnachrichten erkennen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ja. Toxic Detector analysiert Tonfall, Schuldgefühle, Love-Bombing-Zyklen, Inkonsistenz und emotionale Manipulationsmuster, um verdecktes narzisstisches Verhalten zu markieren.'
      }
    }, {
      '@type': 'Question',
      name: 'Was sind häufige Verhaltensweisen verdeckter Narzissten in Texten?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Emotionale Manipulation, Gaslighting, passiv-aggressive Kommentare, das Opfer spielen, Love-Bombing gefolgt von Rückzug und subtile Kontrolle.'
      }
    }, {
      '@type': 'Question',
      name: 'Wie kann ich mich vor einem verdeckten Narzissten schützen?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Dokumentieren Sie Nachrichten, vertrauen Sie Ihrem Instinkt, setzen Sie Grenzen und nutzen Sie Tools wie Toxic Detector, um manipulative Muster objektiv zu identifizieren.'
      }
    }, {
      '@type': 'Question',
      name: 'Wie genau ist Toxic Detector beim Erkennen von verdecktem Narzissmus?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sehr genau. Die KI analysiert sprachliche Muster, Tonfall, emotionalen Druck und subtile Hinweise über mehrere Chats hinweg, um sofortige, zuverlässige Erkenntnisse zu liefern.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg',
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  const alternateUrls = ['https://toxicdetector.com/de/blog/is-your-ex-a-covert-narcissist', 'https://toxicdetector.com/de/blog/is-your-ex-a-covert-narcissist'];
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Link in die Zwischenablage kopiert!');
    }
  };
  return <>
      <MetaTags title="Ist Ihr Ex ein verdeckter Narzisst? Wie KI verborgene Manipulation erkennt | ToxicDetector" description="Fragen Sie sich, ob Ihr Ex ein verdeckter Narzisst ist? Entdecken Sie 7 subtile manipulative Verhaltensweisen, die unsere KI sofort in Textnachrichten erkennt." keywords="verdeckter Narzisst Anzeichen, verborgenes narzisstisches Verhalten, Narzisst Manipulation Texte, KI Narzissmus Detektor, emotionale Manipulation in Beziehungen" canonical={`https://toxicdetector.com/de/blog/${articleData.slug}`} language="de" alternateUrls={alternateUrls} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-4383" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-4384">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-4385">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-4386">
            <div className="flex items-center justify-between" data-id="element-4387">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-4388">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Artikel teilen" data-id="element-4389">
                <Share2 size={20} className="text-gray-600" data-id="element-4390" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-4391">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-4392">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-4393" />
            Zurück zum Blog
          </Link>

          <header className="mb-12" data-id="element-4394">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-4395">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-4396">
              <time dateTime={articleData.publishDate} data-id="element-4397">
                {new Date(articleData.publishDate).toLocaleDateString('de-DE', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-4398">•</span>
              <span data-id="element-4399">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-4400">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="Frau analysiert Textnachrichten auf Anzeichen von verdeckter narzisstischer Manipulation mit KI" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-4401" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-4402">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-4403">
              Inhaltsverzeichnis
            </h2>
            <ul className="space-y-3 text-sm" data-id="element-4404">
              <li data-id="element-4405">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4406">
                  <span className="text-gray-400" data-id="element-4407">→</span> 1. Emotionale
                  Manipulation in jeder Nachricht
                </a>
              </li>
              <li data-id="element-4408">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4409">
                  <span className="text-gray-400" data-id="element-4410">→</span> 2. Gaslighting, das
                  sich langsam aufbaut
                </a>
              </li>
              <li data-id="element-4411">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4412">
                  <span className="text-gray-400" data-id="element-4413">→</span> 3. Passiv-aggressive
                  Kommentare
                </a>
              </li>
              <li data-id="element-4414">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4415">
                  <span className="text-gray-400" data-id="element-4416">→</span> 4. Ständig das Opfer
                  spielen
                </a>
              </li>
              <li data-id="element-4417">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4418">
                  <span className="text-gray-400" data-id="element-4419">→</span> 5. Love-Bombing dann
                  Rückzug
                </a>
              </li>
              <li data-id="element-4420">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4421">
                  <span className="text-gray-400" data-id="element-4422">→</span> 6. Versteckte
                  Kontrolle & Überwachung
                </a>
              </li>
              <li data-id="element-4423">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4424">
                  <span className="text-gray-400" data-id="element-4425">→</span> 7. Inkonsistenter Ton
                  zwischen Kanälen
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-4426">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-4427">
              Hattest du jemals das Gefühl, dass dein Ex dich hinter den
              Kulissen manipuliert hat, während er charmant und fürsorglich
              wirkte? Das sind klassische{' '}
              <strong data-id="element-4428">Anzeichen eines verdeckten Narzissten</strong>. Im
              Gegensatz zu offensichtlichen Narzissten verstecken verdeckte ihre
              Manipulation hinter subtilen, emotionalen Taktiken.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-4429">
              Unsere <strong data-id="element-4430">KI erkennt versteckte Manipulation</strong> sofort
              durch die Analyse ihrer Texte. Hier ist wie.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-4431">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4432">
                1️⃣ Emotionale Manipulation in jeder Nachricht
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4433">
                Verdeckte Narzissten verdrehen Emotionen, um ihren Willen
                durchzusetzen.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4434">
                <p className="italic text-gray-700 text-lg" data-id="element-4435">
                  "Ich kann nicht glauben, dass du dich darüber aufregst..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4436">
                Die KI erkennt subtile Schuldgefühle und emotionalen Druck, der
                in alltäglichen Nachrichten versteckt ist.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-4437">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4438">
                2️⃣ Gaslighting, das sich langsam aufbaut
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4439">
                <p className="italic text-gray-700 text-lg" data-id="element-4440">
                  "Das hast du falsch in Erinnerung..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4441">
                Verdeckte Narzissten lassen dich an deinem eigenen Gedächtnis
                zweifeln. Die KI markiert wiederholte Fälle, in denen die
                Realität verdreht wird.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-4442">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4443">
                3️⃣ Passiv-aggressive Kommentare
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4444">
                <p className="italic text-gray-700 text-lg" data-id="element-4445">
                  "Sicher, was auch immer dich glücklich macht..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4446">
                Passive Aggression ist ein Kennzeichen von verdecktem
                Narzissmus. Die KI erkennt Sarkasmus, hinterhältige Sticheleien
                und maskierte Feindseligkeit.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-4447">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4448">
                4️⃣ Ständig das Opfer spielen
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4449">
                <p className="italic text-gray-700 text-lg" data-id="element-4450">
                  "Nach allem, was ich für dich getan habe..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4451">
                Verdeckte Narzissten drehen oft die Schuld um und machen sich
                selbst zum Opfer. Die KI erkennt Phrasen, die darauf ausgelegt
                sind, Schuldgefühle zu erzeugen.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-4452">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4453">
                5️⃣ Love-Bombing dann Rückzug
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4454">
                <p className="italic text-gray-700 text-lg" data-id="element-4455">
                  "Du bist die Einzige, die ich je geliebt habe 😢" → Ghosting
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4456">
                Dieser klassische Zyklus von intensiver Zuneigung gefolgt von
                emotionaler Distanz ist ein Warnsignal. Die KI identifiziert
                diese Muster über mehrere Chats hinweg.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-4457">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4458">
                6️⃣ Versteckte Kontrolle & Überwachung
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4459">
                <p className="italic text-gray-700 text-lg" data-id="element-4460">
                  "Ich wollte nur mal nachfragen... schon wieder"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4461">
                Subtile Kontrolle, die als Fürsorge getarnt ist, ist eine
                verdeckte Taktik. Die KI markiert wiederholtes Kontrollieren
                ohne offene Aggression.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-4462">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4463">
                7️⃣ Inkonsistenter Ton zwischen Kanälen
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4464">
                <p className="italic text-gray-700 text-lg" data-id="element-4465">
                  Gruppenchat: verspielt / 1:1: kritisch
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4466">
                Verdeckte Narzissten maskieren ihr Verhalten oft öffentlich,
                während sie privat manipulieren. Die KI vergleicht Gespräche, um
                Diskrepanzen aufzuzeigen.
              </p>
            </section>

            <section className="mb-12" data-id="element-4467">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4468">
                🛡 Wie Sie sich schützen können
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-4469">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-4470">
                  <li className="flex items-start gap-3" data-id="element-4471">
                    <span className="text-purple-600 font-bold" data-id="element-4472">•</span>
                    <span data-id="element-4473">
                      Vertrauen Sie Ihrem Instinkt. Ignorieren Sie keine
                      Warnsignale.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4474">
                    <span className="text-purple-600 font-bold" data-id="element-4475">•</span>
                    <span data-id="element-4476">Bewahren Sie Screenshots zur Klarheit auf.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4477">
                    <span className="text-purple-600 font-bold" data-id="element-4478">•</span>
                    <span data-id="element-4479">
                      Teilen Sie Ihre Erfahrungen mit Freunden oder einem
                      Therapeuten.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-4480">
                    <span className="text-purple-600 font-bold" data-id="element-4481">•</span>
                    <span data-id="element-4482">
                      Nutzen Sie Tools wie Toxic Detector, um Muster zu
                      identifizieren.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-4483">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4484">
                💀 Sehen Sie es mit eigenen Augen
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4485">
                Verdeckter Narzissmus kann schwer zu erkennen sein, aber KI
                übersieht nichts. Laden Sie Ihre Chats hoch und erhalten Sie
                eine sofortige Analyse:
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-4486">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-4487">
                  "🚩 78% Manipulation erkannt. Verdeckte Taktiken
                  identifiziert!"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-4488">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-4489">
                Häufig gestellte Fragen
              </h2>
              <div className="space-y-4" data-id="element-4490">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-4491">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-4492">
                      <span data-id="element-4493">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-4494" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-4495">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-4496">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-4497">
              💀 Bereit, die Wahrheit aufzudecken?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-4498">
              Hören Sie auf zu raten. Laden Sie Ihre Texte bei Toxic Detector
              hoch und erhalten Sie einen sofortigen Toxizitäts-Score. Unsere KI
              enthüllt verdeckte Manipulation, die Sie vielleicht übersehen
              haben.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-4499">
              <p className="font-bold text-xl" data-id="element-4500">
                "🚩 78% Manipulation erkannt. Verdeckte Taktiken identifiziert!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-4501">
              Scannen Sie Ihre Chats jetzt →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '7 Anzeichen von Gaslighting, die unsere KI sofort erkennt',
          description: 'Lerne die wichtigsten Gaslighting-Muster, die KI in deinen Textgesprächen erkennt.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Der ultimative Guide zu passiv-aggressiven Texten',
          description: 'Erkenne passiv-aggressives Verhalten und versteckte Manipulation in Textnachrichten.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-4502" />

          <div className="mt-12 text-center" data-id="element-4503">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-4504">
              <Share2 size={18} className="mr-2" data-id="element-4505" />
              Diesen Artikel teilen
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-4506">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-4507">
            <p className="text-gray-500 text-sm" data-id="element-4508">
              © {new Date().getFullYear()} ToxicDetector. Alle Rechte
              vorbehalten.
            </p>
          </div>
        </footer>
      </div>
    </>;
}